import { InfoCircleOutlined, MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { Breadcrumb, Button, Checkbox, Col, DatePicker, Form, Input, message, Radio, Row, Select, Spin, Tooltip, Upload } from 'antd';
import { debounce } from 'lodash';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { ReactComponent as Back } from '../../Images/Back.svg';
import { TOLERANCE_OPTIONS } from '../../constants/toleranceOptions';
import { createNumberValidationRule } from '../../utils/CreateNumberValidationRule';
import AutoOpenSelect from '../SelectComponent/AutoOpenSelect';
import {
  fetchAlloyDropdown,
  resetAlloyList,
  resetCurrentAlloyListPage,
} from '../../slices/alloy';
import {
  fetchCustomerDropdown,
  resetCurrentCustomerPage,
  resetCustomerList,
  fetchCustomerConversionList,
} from '../../slices/customer';
import {
  fetchTemperDropdown,
  resetCurrentTemperPage,
  resetTempersList,
} from '../../slices/tempers';
import {
  fetchDieProfileById,
  fetchDieProfileDropdown,
  resetDieProfileData,
  resetDieProfileList,
} from './../../slices/die-profile';

import { createWorkOrder } from '../../slices/work-order';
import moment from 'moment';
import { fetchNalcoRateForQuotation } from '../../slices/nalco-rate';
import ExcessStockCount from './ExcessStockCount';
import {
  createjobWorkList,
  fetchjobWorkList,
  resetJobWorkList,
} from '../../slices/job-work';
import { fetchPackingModeList, resetPackingModeData } from '../../slices/packing';
import { fetchUserList, resetUserList } from '../../slices/user';

const { Option } = Select;

function CreateWorkOrder() {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const [sameCustomer, setSameCustomer] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [searchAlloy, setSearchAlloy] = useState('');
  const [search, setSearch] = useState('');
  const [orderBy, setOrderBy] = useState('');
  const [form] = Form.useForm();
  const [selectedDieProfile, setSelectedDieProfile] = useState(null);
  const [searchCustomer, setSearchCustomer] = useState('');
  const [currentWTKg, setCurrentWTKg] = useState('');
  const [searchTemper, setSearchTemper] = useState('');
  const [forceOpen, setForceOpen] = useState(false);
  const [isRemarkRequired, setIsRemarkRequired] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [excessStockKey, setExcessStockKey] = useState(0);


  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [searchDieProfile, setSearchDieProfile] = useState('');
  const [searchGroup, setSearchGroup] = useState('');
  const [showDropdownLoader, setShowDropdownLoader] = useState(false);

  useEffect(() => {
    const orderDate = dayjs();
    const purchaseOrderDate = dayjs();
    const deliveryDate = orderDate.clone().add(12, 'days');
    form.setFieldsValue({
      order_date: orderDate,
      delivery_date: deliveryDate,
      purchase_order_date: purchaseOrderDate,
    });
  }, [form]);

  const disablePastDates = current => {
    const currentOrderDate = form.getFieldValue('order_date') || moment();
    return (
      current && current < moment.max(moment().startOf('day'), currentOrderDate)
    );
  };
  const { list: dieProfileDropdown, loading: dieProfileLoading, currentPage: dieProfileCurrentPage, hasMore: dieProfileHasMore } = useSelector(state => state.dieProfile);
  const {
    list: alloyList,
    loading: alloyLoading,
    currentPage: alloyCurrentPage,
    hasMore: alloyHasMore,
  } = useSelector(state => state.alloy);
  const { jobWorkdata, loading: jobWorkLoading } = useSelector(
    state => state.jobWork,
  );
  const {
    list: temperList,
    loading: temperLoading,
    hasMore: temperHasMore,
  } = useSelector(state => state.temper);
  const { list: customerList } = useSelector(state => state.customer);
  const { data: packingModeList, loading: packingModeLoading } = useSelector(state => state.packingMode);
  const { list: userNameList } = useSelector(state => state.user);

  useEffect(() => {
    if (selectedIndex === null) return;
    const workOrderDetails = form.getFieldValue('work_order_details') || [];
    const updatedDetails = [...workOrderDetails];
    const item = updatedDetails[selectedIndex];

    if (item) {
      const currentKg = currentWTKg || 0;
      const length = parseFloat(item.length) || 0;
      const pieces = parseFloat(item.pieces) || 0;
      const netWeight = ((currentKg * length) / 1000) * pieces;
      const toleranceValue = form.getFieldValue('tolerance') || '';
      const tolerancePercent = toleranceValue
        ? parseFloat(toleranceValue.replace(/[^\d.]/g, '')) || 0
        : 0;
      const isPositive = toleranceValue.includes('+');
      const isNegative = toleranceValue.includes('-');
      let max_weight = netWeight;
      let min_weight = netWeight;

      if (tolerancePercent > 0) {
        if (isPositive && isNegative) {
          max_weight = netWeight * (1 + tolerancePercent / 100);
          min_weight = netWeight * (1 - tolerancePercent / 100);
        } else if (isPositive) {
          max_weight = netWeight * (1 + tolerancePercent / 100);
          min_weight = netWeight;
        } else if (isNegative) {
          min_weight = netWeight * (1 - tolerancePercent / 100);
          max_weight = netWeight;
        }
      }
      updatedDetails[selectedIndex] = {
        ...item,
        net_weight: netWeight.toFixed(2),
        max_weight: max_weight.toFixed(3),
        min_weight: min_weight.toFixed(3),
      };
      form.setFieldsValue({
        work_order_details: updatedDetails,
      });
    }
  }, [currentWTKg, selectedIndex, form]);

  const handleRefreshExcessStock = (index, field) => {
    setExcessStockKey(prevKey => prevKey + 1);
  };
  const handleSearchCustomer = value => {
    setSearchCustomer(value);
    if (value) {
      dispatch(fetchCustomerDropdown({ page: 1, pagesize: 1000, search: value }));
      setSearchCustomer(value);
    } else {
      dispatch(fetchCustomerDropdown({ page: 1, pagesize: 1000 }));
      setSearchCustomer('');
      dispatch(resetCurrentCustomerPage());
    }
  };
  const [pricePerKg, setPricePerKg] = useState('');
  const [checkedRows, setCheckedRows] = useState({});

  const handleCheckboxChange = (index, checked) => {
    const updatedWorkOrderDetails = form.getFieldValue('work_order_details') || [];
    updatedWorkOrderDetails[index] = {
      ...updatedWorkOrderDetails[index],
      modify_nalco_rate: checked,
    };

    form.setFieldsValue({ work_order_details: updatedWorkOrderDetails });
    setCheckedRows(prevState => ({
      ...prevState,
      [index]: checked,
    }));
  };


  const handleNalcoChange = value => {
    setIsRemarkRequired(value && parseFloat(value) > 0);
  };

  const getClassNameDieProfile = () => {
    const selected = dieProfileDropdown.find(
      item => item.id === selectedDieProfile?.value,
    );
    return selected && selected.deleted === 1
      ? 'inactive-option'
      : 'active-option';
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await dispatch(
          fetchNalcoRateForQuotation(),
        );
        if (response?.payload?.success) {
          setPricePerKg(response.payload.data.rate);

          form.setFieldsValue({
            work_order_details: [
              {
                nalco_rate: response.payload.data.rate,
              },
            ],
          });
        } 
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, [dispatch]);

  const handleChangeCustomer = value => {
    setSameCustomer(true);
    form.setFieldsValue({
      ship_to: value,
    });
    setSearchCustomer(value);
  };

  useEffect(() => {
    dispatch(resetPackingModeData());
    dispatch(resetUserList());
    dispatch(resetJobWorkList());
    dispatch(resetCustomerList());
    dispatch(
      fetchCustomerDropdown({
        page: 1,
        pagesize: 1000,
        ...(search && { search: search }),
        ...(orderBy && { ordering: orderBy }),
      }),

      dispatch(
        fetchAlloyDropdown({
          page: 1,
          pagesize: 1000,
          ...(search && { search: search }),
          ...(orderBy && { ordering: orderBy }),
        }),
      ),
      dispatch(
        fetchTemperDropdown({
          page: 1,
          pagesize: 1000,
          ...(search && { search: search }),
          ...(orderBy && { ordering: orderBy }),
        }),
      ),
    );

    dispatch(
      fetchDieProfileDropdown({
        page: 1,
        pagesize: 50000,
        ...(search && { search: search }),
        ...(orderBy && { ordering: orderBy }),
      }),
    );
    dispatch(fetchPackingModeList({ page: 1, pagesize: 100 }));
    dispatch(fetchUserList({ page: 1, pagesize: 1000 }));
    dispatch(fetchjobWorkList());
    dispatch(resetDieProfileList());
    dispatch(resetCurrentCustomerPage());
    dispatch(resetCurrentAlloyListPage());
    dispatch(resetTempersList());
    dispatch(resetCurrentTemperPage());
    dispatch(resetAlloyList());
  }, [dispatch]);


  useEffect(() => {
    form.setFieldsValue({ tolerance: '+10%' });
    handleToleranceChange('+10%');
  }, []); // ✅ run once

  const handleToleranceChange = value => {
    const workOrderDetails = form.getFieldValue('work_order_details') || [];
    const toleranceMatch = value.match(/(\+-|\+|-)?\d+/g);
    const toleranceValue = toleranceMatch
      ? Math.abs(parseFloat(toleranceMatch[0].replace('+-', '')))
      : 0;
    const hasPositive =
      toleranceMatch.some(val => val.includes('+')) && !value.includes('+-');
    const hasNegative =
      toleranceMatch.some(val => val.includes('-')) && !value.includes('+-');
    const hasBoth = value.includes('+-') || value.includes('±');
    const updatedDetails = workOrderDetails.map(item => {
      const netWeight = parseFloat(item.net_weight) || 0;

      let max_weight = netWeight;
      let min_weight = netWeight;

      if (toleranceValue > 0) {
        if (hasBoth) {
          max_weight = netWeight * (1 + toleranceValue / 100);
          min_weight = netWeight * (1 - toleranceValue / 100);
        } else if (hasPositive) {
          max_weight = netWeight * (1 + toleranceValue / 100);
          min_weight = netWeight;
        } else if (hasNegative) {
          min_weight = netWeight * (1 - toleranceValue / 100);
          max_weight = netWeight;
        }
      }

      return {
        ...item,
        max_weight: max_weight.toFixed(3),
        min_weight: min_weight.toFixed(3),
      };
    });
    form.setFieldsValue({ work_order_details: updatedDetails });
  };

  const handleSameCustomerCheck = e => {
    const checked = e.target.checked;
    setSameCustomer(checked);

    if (checked) {
      const selectedCustomer = form.getFieldValue('bill_to');
      form.setFieldsValue({
        ship_to: selectedCustomer,
      });
    } else {
      form.setFieldsValue({
        ship_to: undefined,
      });
    }
  };

  const handleFinish = async values => {
    setBtnLoading(true);
    console.log(values);
    const { po_copy, ...restValues } = values;
    const updatedWorkOrderDetails = values.work_order_details.map(
      ({ wt_kg_p_mt, jobworks, out_source, ...item }) => {
        const detail = {
          ...item,
          pieces: parseFloat(item.pieces) || null,
          min_weight: parseFloat(item.min_weight) || null,
          max_weight: parseFloat(item.max_weight) || null,
          length: parseFloat(item.length) || null,
          nalco_rate: parseFloat(item.nalco_rate) || null,
          jobworks: Array.isArray(jobworks) ? jobworks : [],
          packing_charge: parseFloat(item.packing_charge) || null,
          cutting: item?.cutting || false,
          machining: item?.machining || false,
          anodising: item?.anodising || false,
          powder_coating: item?.powder_coating || false,
          pvdf: item?.pvdf || false,
          surface_finish: item.surface_finish,
          modify_nalco_rate: item?.modify_nalco_rate || false,
          net_weight: parseFloat(item.net_weight) || null,
          conversion: item.conversion || null,
        };

        if (jobworks?.includes(4) && out_source != null) {
          detail.out_source = out_source; // out_source should already be boolean (true/false)
        }

        return detail;
      },
    );

    const formattedValues = {
      ...restValues,
      delivery_date: dayjs(values.delivery_date).format('YYYY-MM-DD'),
      order_date: dayjs(values.order_date).format('YYYY-MM-DD'),
      purchase_order_date: dayjs(values.purchase_order_date).format(
        'YYYY-MM-DD',
      ),
      work_order_details: updatedWorkOrderDetails,
    };

   

    const formData = new FormData();
    formData.append('data', JSON.stringify(formattedValues));
    if (fileList.length > 0 && fileList[0]?.originFileObj) {
      formData.append('po_copy', fileList[0].originFileObj);
    }

    try {
      const result = await dispatch(
        createWorkOrder({ values: formData }),
      ).unwrap();
      setBtnLoading(false);
      if (result.success) {
        const workOrderId = result.data?.id;
        try {
          await dispatch(createjobWorkList(workOrderId)).unwrap();

          message.success('Work Order Created Successfully!');
          navigate('/work-order-list');
        } catch (secondErr) {
          message.error(
            'Work order created, but failed to fetch additional data',
          );
          console.error(secondErr);

          navigate('/work-order-list');
        }
      }
    } catch (error) {
      setBtnLoading(false);

      const messages = [];
      if (typeof error === 'object' && error !== null) {
        for (const key in error) {
          if (Array.isArray(error[key])) {
            messages.push(`${key}: ${error[key].join(', ')}`);
          }
        }
      }
      if (messages.length > 0) {
        message.error(messages.join('; '));
      } else if (typeof error === 'string') {
        message.error(error);
      } else {
        message.error('An unknown error occurred.');
      }
    }
  };

  const handleSearchDieProfile = value => {
    setSearchDieProfile(value);

    if (value) {
      dispatch(resetDieProfileData());
      debouncedFetchDieProfile(value, dispatch);
    } else {
      dispatch(resetDieProfileData());
      dispatch(fetchDieProfileDropdown({ page: 1, pagesize: 50 }));
    }
  };
  const debouncedFetchDieProfile = debounce((searchTerm, dispatch) => {
    dispatch(
      fetchDieProfileDropdown({
        page: 1,
        pagesize: 50,
        search: searchTerm,
      }),
    );
  }, 300);

  const onScrollDieProfile = event => {
    const target = event.target;

    if (
      !dieProfileLoading &&
      dieProfileHasMore &&
      target.scrollHeight - target.scrollTop - target.clientHeight < 50
    ) {
      const nextPage = dieProfileCurrentPage + 1;
      dispatch(
        fetchDieProfileDropdown({
          page: nextPage,
          pagesize: 50,
          search: searchDieProfile || '',
        }),
      );
    }
  };

  const handleBillToChange = value => {
    form.setFieldsValue({ bill_to: value });

    if (sameCustomer) {
      form.setFieldsValue({ ship_to: value });
    }
    if (value === form.getFieldValue('ship_to')) {
      setSameCustomer(true);
    } else {
      setSameCustomer(false);
    }
  };

  const handleShipToChange = value => {
    form.setFieldsValue({ ship_to: value });
    if (value === form.getFieldValue('bill_to')) {
      setSameCustomer(true);
    } else {
      setSameCustomer(false);
    }
  };
  const handleSearchAlloy = value => {
    setSearchAlloy(value);
    if (value) {
      setSearchAlloy(value);
      dispatch(fetchAlloyDropdown({ page: 1, pagesize: 1000, search: value }));
    } else {
      setSearchAlloy('');
      dispatch(fetchAlloyDropdown({ page: 1, pagesize: 1000 }));
    }
  };

  const onScrollAlloy = async event => {
    const target = event.target;
    if (
      !alloyLoading &&
      alloyHasMore &&
      target.scrollTop + target.offsetHeight === target.scrollHeight
    ) {
      dispatch(fetchAlloyDropdown({ page: alloyCurrentPage, pagesize: 1000 }));
    }
  };

  const handleSearchTemer = value => {
    setSearchTemper(value);
    if (value) {
      setSearchTemper(value);
      dispatch(fetchTemperDropdown({ page: 1, pagesize: 1000, search: value }));
    } else {
      setSearchTemper('');
      dispatch(fetchTemperDropdown({ page: 1, pagesize: 1000 }));
    }
  };

  const onScrollTemper = async event => {
    const target = event.target;
    if (
      !temperLoading &&
      temperHasMore &&
      target.scrollTop + target.offsetHeight === target.scrollHeight
    ) {
      dispatch(fetchTemperDropdown({ page: alloyCurrentPage, pagesize: 1000 }));
    }
  };

  // const handleFieldChange = (index, changedField, rawValue) => {
  //   console.log("index", index);
  //   console.log("changedField", changedField);
  //   console.log("rawValue", rawValue)
  //   const workOrderDetails = form.getFieldValue('work_order_details') || [];
  //   const row = { ...workOrderDetails[index] } || {};
  //   const currentKg = row?.wt_kg_p_mt || currentWTKg || 0;
  //   const length = parseFloat(row.length) || 0;
  //   const pieces = parseFloat(row.pieces) || 0;
  //   const net_weight = parseFloat(row.net_weight) || 0;

  //   let calculatedNetWeight = net_weight;
  //   let calculatedPieces = pieces;
  //   if (changedField === 'net_weight') {
  //     if (net_weight > 0 && length > 0 && currentKg > 0) {
  //       calculatedPieces = net_weight / (currentKg * (length / 1000));
  //     }
  //   }

  //   if (changedField === 'pieces') {
  //     if (pieces > 0 && length > 0 && currentKg > 0) {
  //       calculatedNetWeight = ((currentKg * length) / 1000) * pieces;
  //       calculatedNetWeight = calculatedNetWeight.toFixed(3);
  //     }
  //   }

  //   if (changedField === 'length') {
  //     if (net_weight > 0 && length > 0 && currentKg > 0) {
  //       calculatedPieces = net_weight / (currentKg * (length / 1000));
  //       calculatedNetWeight =
  //         ((currentKg * length) / 1000) * calculatedPieces.toFixed(0);
  //       calculatedNetWeight = calculatedNetWeight.toFixed(3);
  //     }
  //   }
  //   const toleranceValue = form.getFieldValue('tolerance') || '';
  //   const tolerancePercent = toleranceValue
  //     ? parseFloat(toleranceValue.replace(/[^\d.]/g, '')) || 0
  //     : 0;
  //   const isPositive = toleranceValue.includes('+');
  //   const isNegative = toleranceValue.includes('-');
  //   let max_weight = calculatedNetWeight;
  //   let min_weight = calculatedNetWeight;

  //   if (tolerancePercent > 0) {
  //     if (isPositive && isNegative) {
  //       max_weight = calculatedNetWeight * (1 + tolerancePercent / 100);
  //       min_weight = calculatedNetWeight * (1 - tolerancePercent / 100);
  //     } else if (isPositive) {
  //       max_weight = calculatedNetWeight * (1 + tolerancePercent / 100);
  //       min_weight = calculatedNetWeight;
  //     } else if (isNegative) {
  //       min_weight = calculatedNetWeight * (1 - tolerancePercent / 100);
  //       max_weight = calculatedNetWeight;
  //     }
  //   }
  //   console.log("calculatedNetWeight", calculatedNetWeight);
  //   const updatedWorkOrderDetails = [...workOrderDetails];
  //   const updatedRow = {
  //     ...row,
  //     net_weight: calculatedNetWeight,
  //     max_weight: Number(max_weight)?.toFixed(3),
  //     min_weight: Number(min_weight)?.toFixed(3),
  //     wt_kg_p_mt: currentKg,
  //   };
  //   if (changedField === 'net_weight' || changedField === 'length') {
  //     updatedRow.pieces = Math.round(calculatedPieces);
  //   }
  //   updatedWorkOrderDetails[index] = updatedRow;
  //   form.setFieldsValue({
  //     work_order_details: updatedWorkOrderDetails,
  //   });
  // };

  const handleFieldChange = (index, changedField, rawValue) => {
    const workOrderDetails = form.getFieldValue('work_order_details') || [];
    const row = { ...workOrderDetails[index] };

    const currentKg = row?.wt_kg_p_mt || currentWTKg || 0;
    const length = Number(row.length) || 0;
    const pieces = Number(row.pieces) || 0;

    const netWeightStr =
      changedField === 'net_weight' ? rawValue : row.net_weight;

    const net_weight =
      netWeightStr !== '' && !isNaN(netWeightStr)
        ? Number(netWeightStr)
        : 0;

    let calculatedNetWeight = net_weight;
    let calculatedPieces = pieces;

    if (changedField === 'net_weight' && net_weight > 0 && length > 0 && currentKg > 0) {
      calculatedPieces = net_weight / (currentKg * (length / 1000));
    }

    if (changedField === 'pieces' && pieces > 0 && length > 0 && currentKg > 0) {
      calculatedNetWeight = ((currentKg * length) / 1000) * pieces;
    }

    if (changedField === 'length' && net_weight > 0 && length > 0 && currentKg > 0) {
      calculatedPieces = net_weight / (currentKg * (length / 1000));
      calculatedNetWeight = ((currentKg * length) / 1000) * calculatedPieces;
     
    }

    const toleranceValue = form.getFieldValue('tolerance') || '';
    const tolerancePercent = Number(toleranceValue.replace(/[^\d.]/g, '')) || 0;

    let max_weight = calculatedNetWeight;
    let min_weight = calculatedNetWeight;

    if (tolerancePercent > 0) {
      if (toleranceValue.includes('+') && toleranceValue.includes('-')) {
        max_weight *= 1 + tolerancePercent / 100;
        min_weight *= 1 - tolerancePercent / 100;
      } else if (toleranceValue.includes('+')) {
        max_weight *= 1 + tolerancePercent / 100;
      } else if (toleranceValue.includes('-')) {
        min_weight *= 1 - tolerancePercent / 100;
      }
    }

    const updatedRow = {
      ...row,
      net_weight: changedField === 'net_weight' ? netWeightStr : Number(calculatedNetWeight).toFixed(3),
      max_weight: Number(max_weight).toFixed(3),
      min_weight: Number(min_weight).toFixed(3),
      wt_kg_p_mt: currentKg,
      ...(changedField !== 'pieces' && { pieces: Math.round(calculatedPieces) }),
    };

    workOrderDetails[index] = updatedRow;

    form.setFieldsValue({
      work_order_details: workOrderDetails,
    });
  };

  const handleCompanyNameChange = async value => {
    form.setFieldValue('customer', value);
    form.validateFields(['customer']);
    handleChangeCustomer(value);

    const selectedCustomer = customerList.find(
      customer => customer.id === value,
    );

    const purchaseOrderDate =
      form.getFieldValue('purchase_order_date') || dayjs();

    const deliveryDays = selectedCustomer?.delivery_days || 12;
    const deliveryDate = purchaseOrderDate.add(deliveryDays, 'days');

    form.setFieldsValue({
      delivery_date: dayjs(deliveryDate),
    });

    const quotationDetails = form.getFieldValue('work_order_details');
    const updatedQuotationDetails = [...quotationDetails];
    updatedQuotationDetails.forEach((item, index) => {
      updatedQuotationDetails[index] = {
        ...item,
        conversion: '',
      };
    });

    form.setFieldsValue({ work_order_details: updatedQuotationDetails });
    for (let i = 0; i < updatedQuotationDetails.length; i++) {
      const dieId = updatedQuotationDetails[i]?.die_profile;
      if (dieId) {
        await fetchConversionData(value, dieId, i);
      }
    }
  };

  const handleDieProfileChange = async (value, index) => {
    const updatedQuotationDetails = [
      ...form.getFieldValue('work_order_details'),
    ];
    updatedQuotationDetails[index] = {
      ...updatedQuotationDetails[index],
      die_profile: value,
      conversion: '',
    };
    form.setFieldsValue({ work_order_details: updatedQuotationDetails });
    setSelectedIndex(index);

    try {
      const response = await dispatch(fetchDieProfileById(value)).unwrap();

      if (response?.success) {
        const dieProfileData = response?.data;
        const customerRefNo = dieProfileData?.customer_reference_number || '';
        const currentWTKg = dieProfileData?.wt_kg_p_mt || '';

        updatedQuotationDetails[index] = {
          ...updatedQuotationDetails[index],
          customer_reference_number: customerRefNo,
          wt_kg_p_mt: currentWTKg,
          conversion: '',
        };

        const row = updatedQuotationDetails[index];
        const length = parseFloat(row.length) || 0;
        const pieces = parseFloat(row.pieces) || 0;
        if (length > 0 && pieces > 0 && currentWTKg > 0) {
          const net_weight = (length * currentWTKg * pieces) / 1000;

          const toleranceValue = form.getFieldValue('tolerance') || '';
          const tolerancePercent = toleranceValue
            ? parseFloat(toleranceValue.replace(/[^\d.]/g, '')) || 0
            : 0;
          const isPositive = toleranceValue.includes('+');
          const isNegative = toleranceValue.includes('-');
          let max_weight = net_weight;
          let min_weight = net_weight;
          if (tolerancePercent > 0) {
            if (isPositive && isNegative) {
              max_weight = net_weight * (1 + tolerancePercent / 100);
              min_weight = net_weight * (1 - tolerancePercent / 100);
            } else if (isPositive) {
              max_weight = net_weight * (1 + tolerancePercent / 100);
              min_weight = net_weight;
            } else if (isNegative) {
              min_weight = net_weight * (1 - tolerancePercent / 100);
              max_weight = net_weight;
            }
          }
          updatedQuotationDetails[index] = {
            ...row,
            net_weight: Number(net_weight).toFixed(3),
            max_weight: Number(max_weight).toFixed(3),
            min_weight: Number(min_weight).toFixed(3),
            wt_kg_p_mt: currentWTKg,
          };
        }

        form.setFieldsValue({
          work_order_details: updatedQuotationDetails,
          customer_reference_no: customerRefNo,
        });

        const customerId = form.getFieldValue('customer');
        if (customerId) {
          await fetchConversionData(customerId, value, index);
        }
      }
    } catch (error) {
      console.error('Error fetching die profile data:', error);
    }
  };

  const fetchConversionData = async (customerId, dieId, index) => {
    try {
      const response = await dispatch(
        fetchCustomerConversionList({
          page: 1,
          pagesize: 100,
          customer_id: customerId,
          die_id: dieId,
        }),
      );

      const updatedQuotationDetails = [
        ...form.getFieldValue('work_order_details'),
      ];

      if (response && response.payload.data.length > 0) {
        const conversion = response.payload.data[0].conversion;

        updatedQuotationDetails[index] = {
          ...updatedQuotationDetails[index],
          conversion: conversion,
        };
      } else {
        updatedQuotationDetails[index] = {
          ...updatedQuotationDetails[index],
          conversion: null,
        };
      }

      form.setFieldsValue({ work_order_details: updatedQuotationDetails });
    } catch (error) {
      console.error('Error fetching conversion data:', error);
    }
  };
  const [fileList, setFileList] = useState([]);
  const [uploadDiaDiagramError, setUploadDiaDiagramError] = useState('');

  const validateFileList = () => {
    if (fileList.length === 0) {
      return Promise.reject(new Error('Please upload a file.'));
    }
    return Promise.resolve();
  };

  const handleFileChange = info => {
    const newFileList = info.fileList.slice(-1);
    const uploadedFile = newFileList[0]?.originFileObj;

    if (uploadedFile) {
      if (uploadedFile.size / 1024 / 1024 > 2) {
        setUploadDiaDiagramError('File size must be smaller than 2MB!');
        setFileList([]);
      } else {
        setUploadDiaDiagramError('');
        setFileList(newFileList);
        form.validateFields(['po_copy']);
      }
    } else {
      setUploadDiaDiagramError('');
      setFileList([]);
    }
  };

  return (
    <>
      <div className="sticyaction">
        <div className="pagenamerow">
          <h2>Create Work Order</h2>
          <div className="bredcrumbwrp">
            <Link to="/work-order-list" className="back">
              <Back /> BACK
            </Link>
            <Breadcrumb
              items={[
                { title: <Link to="/dashboard">Home</Link> },
                { title: <Link to="/work-order-list">Work Orders</Link> },
                { title: 'Create Work Order' },
              ]}
            />
          </div>
        </div>
      </div>
      <div className="formwrapper">
        <Form
          form={form}
          layout="vertical"
          onFinish={handleFinish}
          initialValues={{
            order_date: dayjs(),
            delivery_date: '',
            purchase_order_date: '',
            bill_to: null,
            ship_to: null,
            purchase_order_no: '',
            packing_mode: [],
            project_name: '',
            tolerance: null,
            remarks: null,
            po_copy: null,
            nalco_type: 'Variable',
            workorder_type: 'In House',
            work_order_details: [
              {
                die_profile: null,
                customer_reference_number: '',
                alloy: null,
                temper: null,
                length: '',
                net_weight: null,
                packing_charge: null,
                conversion: null,
                pieces: null,
                modify_nalco_rate: false,
                nalco_rate_change_reason: null,
                nalco_rate: null,
                // jobworks: [1],
                cutting: false,
                machinings: false,
                deburring: false,
                anodising: false,
                powder_coating: false,
                pvdf: false,
                out_source: null,
                surface_finish: null,
                anodising_description: '',
                anodising_finishing_price: null,
                powder_coating_description: '',
                powder_coating_finishing_price: null,
                pvdf_description: '',
                pvdf_finishing_price: null,
                machining_price: null,
                cutting_price: null,
                deburring_price: null,
                laser_marking_description: null,
                laser_marking_price: null,
              },
            ],
          }}
        >
          <div className="formrowsection">
            <Row gutter={16}>
              <Col xs={24} sm={12} xl={8} xxl={6}>
                <Form.Item
                  name="bill_to"
                  label="Customer (Bill To)"
                  rules={[{ required: true, message: 'Please select customer' }]}
                >
                  <AutoOpenSelect
                    placeholder="Please Select Company Name"
                    onChange={value => {
                      handleBillToChange(value);
                      handleCompanyNameChange(value);
                    }}
                    showSearch
                    onSearch={handleSearchCustomer}
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  >
                    {[
                      ...new Map(
                        customerList.map(item => [item.id, item]),
                      ).values(),
                    ].map((el, index) => (
                      <Option
                        key={el.id}
                        value={el.id}
                        disabled={el.deleted === 1}
                      >
                        {el.customer_name}
                      </Option>
                    ))}
                  </AutoOpenSelect>
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} xl={8} xxl={6}>
                <label
                  className="customlabel flex"
                  style={{ marginBottom: '3px' }}
                >
                  {' '}
                  Customer (Ship To) -
                  <div className="ml-2">
                    <Checkbox
                      checked={sameCustomer}
                      onChange={handleSameCustomerCheck}
                    >
                      Same as bill to
                    </Checkbox>
                  </div>
                </label>
                <Form.Item name="ship_to">
                  <AutoOpenSelect
                    value={form.getFieldValue('ship_to')}
                    placeholder="Please Select Company Name"
                    onChange={handleShipToChange}
                    showSearch
                    onSearch={handleSearchCustomer}
                    open={isDropdownOpen}
                    onFocus={() => setIsDropdownOpen(true)}
                    onBlur={() => setIsDropdownOpen(false)}
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  >
                    {[
                      ...new Map(
                        customerList.map(item => [item.id, item]),
                      ).values(),
                    ].map((el, index) => (
                      <Option
                        key={el.id}
                        value={el.id}
                        disabled={el.deleted === 1}
                      >
                        {el.customer_name}
                      </Option>
                    ))}
                  </AutoOpenSelect>
                </Form.Item>
              </Col>

              <Col xs={12} sm={6} xl={4}>
                <Form.Item
                  name="order_date"
                  label="Order Date"
                  rules={[
                    { required: true, message: 'Please select order date' },
                  ]}
                >
                  <DatePicker
                    style={{ width: '100%' }}
                    format="DD-MM-YYYY"
                    disabled
                    disabledDate={current =>
                      current && current.isAfter(dayjs(), 'day')
                    }
                  />
                </Form.Item>
              </Col>

              <Col xs={12} sm={6} xl={4}>
                <Form.Item
                  name="delivery_date"
                  label={
                    <>
                      Delivery Date
                      <Tooltip title="Delivery date should be at least 12 days after the order date">
                        <InfoCircleOutlined
                          style={{ marginLeft: 5, color: '#1890ff' }}
                        />
                      </Tooltip>
                    </>
                  }
                  rules={[
                    { required: true, message: 'Please select delivery date' },
                  ]}
                >
                  <DatePicker
                    style={{ width: '100%' }}
                    format="DD-MM-YYYY"
                    disabledDate={disablePastDates}
                    value={form.getFieldValue('delivery_date')}
                    disabled
                    onChange={date => {
                      form.setFieldsValue({ delivery_date: date });
                    }}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} xl={8} xxl={4}>
                <Form.Item
                  name="purchase_order_no"
                  label="Purchase Order No"
                  rules={[
                    {
                      required: true,
                      message: 'Please enter purchase order no',
                    },
                  ]}
                >
                  <Input placeholder="Enter purchase order no." />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} xl={8} xxl={4}>
                <Form.Item
                  name="purchase_order_date"
                  label="Purchase Order Date"
                  rules={[
                    {
                      required: true,
                      message: 'Please select purchase order date',
                    },
                  ]}
                >
                  <DatePicker
                    style={{ width: '100%' }}
                    format="DD-MM-YYYY"
                    disabledDate={current =>
                      current && current.isAfter(dayjs(), 'day')
                    }
                  />
                </Form.Item>
              </Col>
              <Col xs={12} md={8} xl={6} xxl={4}>
                <Form.Item
                  name="packing_mode"
                  label="Mode Of Packing"
                  rules={[
                    { required: true, message: 'Please select mode of packing' },
                  ]}
                >
                  <AutoOpenSelect
                    placeholder="Select Mode Of Packing"
                    options={Array.from(
                      new Map(
                        packingModeList.map(item => [item.id, { label: item.name, value: item.id }])
                      ).values()
                    )}
                    mode="multiple"
                    loading={packingModeLoading}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} xl={8} xxl={4}>
                <Form.Item
                  name="project_name"
                  label="Project Name"
                  rules={[
                    {
                      required: true,
                      message: 'Please enter project name',
                    },
                  ]}
                >
                  <Input
                    placeholder="Enter Project Name"
                    onChange={e => {
                      const value = e.target.value;
                      const formattedValue = value
                        .toLowerCase()
                        .replace(/\b\w/g, char => char.toUpperCase());
                      form.setFieldsValue({ project_name: formattedValue });
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} xl={8} xxl={4}>
                <Form.Item
                  name="tolerance"
                  label="Tolerance"
                  rules={[
                    {
                      required: true,
                      message: 'Please select a tolerance value',
                    },
                  ]}
                >
                  <AutoOpenSelect
                    placeholder="Select Tolerance"
                    onChange={handleToleranceChange}
                  >
                    {TOLERANCE_OPTIONS.map(opt => (
                      <Option
                        key={opt.value}
                        value={opt.value}
                        style={opt.label.startsWith('±') ? { letterSpacing: '2px' } : undefined}
                      >
                        {opt.label}
                      </Option>
                    ))}
                  </AutoOpenSelect>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} xl={8} xxl={4}>
                <Form.Item
                  name="nalco_type"
                  label="Nalco Rate"
                  rules={[
                    { required: true, message: 'Please select nalco rate' },
                  ]}
                >
                  <Radio.Group>
                    <Radio value="Fixed">Fixed</Radio>
                    <Radio value="Variable">Variable</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} xl={8} xxl={4}>
                <Form.Item
                  name="workorder_type"
                  label="Work Order Type"
                  rules={[
                    { required: true, message: 'Please select work order type' },
                  ]}
                >
                  <Radio.Group disabled>
                    <Radio value="In House">In House</Radio>
                    <Radio value="Job Work">Job Work</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} lg={12} xxl={12}>
                <Form.Item name="remarks" label="Remarks">
                  <Input.TextArea
                    placeholder="Enter remarks"
                    onChange={e => {
                      const value = e.target.value;

                      const formattedValue =
                        value.trim() === ''
                          ? null
                          : value
                            .toLowerCase()
                            .replace(/\b\w/g, char => char.toUpperCase());

                      form.setFieldsValue({ remarks: formattedValue });
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} xl={4}>
                <Form.Item
                  name="po_copy"
                  label="Purchase Order Copy"
                  required
                  valuePropName="fileList"
                  rules={[
                    {
                      validator: validateFileList,
                    },
                  ]}
                >
                  <div>
                    <Upload
                      beforeUpload={() => false}
                      listType="picture"
                      accept=".pdf,.jpeg,.jpg,.png"
                      maxCount={1}
                      onChange={handleFileChange}
                      fileList={fileList}
                      showUploadList={{
                        showPreviewIcon: true,
                        showRemoveIcon: true,
                      }}
                    >
                      {fileList.length < 1 && (
                        <div
                          style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: '8px 16px',
                            borderRadius: '6px',
                            backgroundColor: ' #FFFBF6',
                            color: 'black',
                            cursor: 'pointer',
                            fontWeight: '500',
                            fontSize: '14px',
                            gap: '8px',
                          }}
                        >
                          <PlusOutlined />
                          <span>Upload</span>
                        </div>
                      )}
                    </Upload>
                  </div>
                  {uploadDiaDiagramError && (
                    <div style={{ color: 'red', marginTop: 5 }}>
                      {uploadDiaDiagramError}
                    </div>
                  )}
                  <label className="filenote">
                    Upload PDF, JPEG, JPG or PNG file
                  </label>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} xl={8} xxl={4}>
                <Form.Item shouldUpdate={(prev, curr) => prev.nalco_type !== curr.nalco_type}>
                  {({ getFieldValue }) =>
                    getFieldValue("nalco_type") === "Fixed" ? (
                      <Form.Item
                        name="approved_by"
                        label="Approved By"
                        rules={[{ required: true, message: "Please select user" }]}
                      >
                        <Select placeholder="Select user">
                          {userNameList?.map((user) => (
                            <Select.Option key={user.id} value={user.id}>
                              {user?.first_name} {user?.last_name}
                            </Select.Option>
                          ))}
                        </Select>
                      </Form.Item>
                    ) : null
                  }
                </Form.Item>
              </Col>
            </Row>
          </div>

          <div className="formrowsection">
            <h3 className="rowsubtitle">Add New Item</h3>
            <Form.List name="work_order_details">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }, index) => (
                    <div key={key}>
                      <ExcessStockCount
                        profileId={form.getFieldValue([
                          'work_order_details',
                          name,
                          'die_profile',
                        ])}
                        length={form.getFieldValue([
                          'work_order_details',
                          name,
                          'length',
                        ])}
                        alloyId={form.getFieldValue([
                          'work_order_details',
                          name,
                          'alloy',
                        ])}
                        temperId={form.getFieldValue([
                          'work_order_details',
                          name,
                          'temper',
                        ])}
                      />
                      <Row
                        gutter={[24, 24]}
                        className="rowItem mx-0"
                        align="middle"
                        key={key}
                        wrap={false}
                        style={{ width: '100%' }}
                      >
                        <Col flex="auto">
                          <Row gutter={[16]} key={key}>
                            <Col xs={12} md={8} xl={6} xxl={4}>
                              <Form.Item
                                {...restField}
                                name={[name, 'die_profile']}
                                label="Section Number"
                                rules={[
                                  {
                                    required: true,
                                    message: 'Please select a section number',
                                  },
                                ]}
                              >
                                <AutoOpenSelect
                                  placeholder="Select Section No"
                                  style={{ width: '100%' }}
                                  onChange={value =>
                                    handleDieProfileChange(value, name)
                                  }
                                  value={searchGroup}
                                  labelInValue={false}
                                  loading={dieProfileLoading}
                                  open={forceOpen || undefined}
                                  onPopupScroll={onScrollDieProfile}
                                  notFoundContent={null}
                                  showSearch={true}
                                  onSearch={handleSearchDieProfile}
                                  allowClear
                                  filterOption={(input, option) =>
                                    option.children
                                      .toLowerCase()
                                      .includes(input.toLowerCase())
                                  }
                                  className={getClassNameDieProfile()}
                                  dropdownRender={menu => (
                                    <>
                                      {showDropdownLoader ? (
                                        <div
                                          style={{
                                            padding: '16px',
                                            textAlign: 'center',
                                          }}
                                        >
                                          <Spin size="small" />
                                        </div>
                                      ) : (
                                        menu
                                      )}
                                    </>
                                  )}
                                >
                                  {showDropdownLoader ? (
                                    <Option key="loading" disabled>
                                      Loading...
                                    </Option>
                                  ) : (
                                    dieProfileDropdown.map(el => (
                                      <Option
                                        key={el.id}
                                        value={el.id}
                                        disabled={el.deleted === 1}
                                      >
                                        {el.die_number}
                                      </Option>
                                    ))
                                  )}
                                </AutoOpenSelect>
                              </Form.Item>
                            </Col>
                            <Col xs={12} md={8} xl={6} xxl={4}>
                              <Form.Item
                                name={[name, 'customer_reference_number']}
                                label="Customer Reference No."
                              >
                                <Input
                                  placeholder="Enter Customer Ref. No"
                                  disabled
                                />
                              </Form.Item>
                            </Col>
                            <Col xs={12} md={8} xl={6} xxl={4}>
                              <Form.Item
                                {...restField}
                                name={[name, 'alloy']}
                                label="Alloy"
                                rules={[
                                  {
                                    required: true,
                                    message: 'Please select alloy',
                                  },
                                ]}
                              >
                                <AutoOpenSelect
                                  placeholder="Select Alloy"
                                  loading={alloyLoading}
                                  onPopupScroll={onScrollAlloy}
                                  notFoundContent={
                                    alloyLoading ? 'Loading...' : 'No options'
                                  }
                                  value={
                                    form.getFieldValue([
                                      'work_order_details',
                                      name,
                                      'alloy',
                                    ])
                                      ? {
                                        value: form.getFieldValue([
                                          'work_order_details',
                                          name,
                                          'alloy',
                                        ]),
                                        label: '',
                                      }
                                      : undefined
                                  }
                                  onChange={value => {
                                    form.setFieldValue(
                                      ['work_order_details', name, 'alloy'],
                                      value,
                                    );
                                    handleRefreshExcessStock(index, 'alloy');
                                  }}
                                  onSearch={handleSearchAlloy}
                                  allowClear
                                  showSearch={true}
                                  filterOption={(input, option) => {
                                    if (!input) return true;
                                    const optionText = (option?.children || '')
                                      .toString()
                                      .replace(/\s+/g, '')
                                      .toLowerCase();
                                    const inputText = input
                                      .replace(/\s+/g, '')
                                      .toLowerCase();
                                    return optionText.includes(inputText);
                                  }}
                                  dropdownRender={menu => <>{menu}</>}
                                >
                                  {[
                                    ...new Map(
                                      alloyList.map(item => [item.id, item]),
                                    ).values(),
                                  ].map((el, index) => (
                                    <Option
                                      key={el.id}
                                      value={el.id}
                                      disabled={el.deleted === 1}
                                    >
                                      {el?.alloy_code} - {el?.standard_name}
                                    </Option>
                                  ))}
                                </AutoOpenSelect>
                              </Form.Item>
                            </Col>
                            <Col xs={12} md={8} xl={6} xxl={4}>
                              <Form.Item
                                {...restField}
                                name={[name, 'temper']}
                                label="Temper"
                                rules={[
                                  {
                                    required: true,
                                    message: 'Please select temper',
                                  },
                                ]}
                              >
                                <AutoOpenSelect
                                  placeholder="Select Temper"
                                  loading={temperLoading}
                                  onPopupScroll={onScrollTemper}
                                  value={
                                    form.getFieldValue([
                                      'work_order_details',
                                      name,
                                      'temper',
                                    ])
                                      ? {
                                        value: form.getFieldValue([
                                          'work_order_details',
                                          name,
                                          'temper',
                                        ]),
                                        label: '',
                                      }
                                      : undefined
                                  }
                                  onChange={value => {
                                    form.setFieldValue(
                                      ['work_order_details', name, 'temper'],
                                      value,
                                    );
                                    handleRefreshExcessStock(index, 'temper');
                                  }}
                                  filterOption={(input, option) => {
                                    if (!input) return true;
                                    const optionText = (option?.children || '')
                                      .toString()
                                      .replace(/\s+/g, '')
                                      .toLowerCase();
                                    const inputText = input
                                      .replace(/\s+/g, '')
                                      .toLowerCase();
                                    return optionText.includes(inputText);
                                  }}
                                  onSearch={handleSearchTemer}
                                  allowClear
                                  showSearch={true}
                                  notFoundContent={
                                    temperLoading ? 'Loading...' : 'No options'
                                  }
                                  dropdownRender={menu => <>{menu}</>}
                                >
                                  {[
                                    ...new Map(
                                      temperList.map(item => [item.id, item]),
                                    ).values(),
                                  ].map((el, index) => (
                                    <Option
                                      key={el.id}
                                      value={el.id}
                                      disabled={el.deleted === 1}
                                    >
                                      {el.temper_code_new} - {el.temper_code_old}
                                    </Option>
                                  ))}
                                </AutoOpenSelect>
                              </Form.Item>
                            </Col>

                            <Col>
                              <Form.Item
                                {...restField}
                                name={[name, 'length']}
                                label="Length (mm)"
                                rules={[
                                  {
                                    required: true,
                                    message: 'Please enter length',
                                  },
                                ]}
                              >
                                <Input
                                  maxLength={6}
                                  placeholder="0"
                                  onChange={() => {
                                    setTimeout(
                                      () => handleFieldChange(index, 'length'),
                                      0,
                                    );
                                  }}
                                  style={{ width: '100px' }}
                                />
                              </Form.Item>
                            </Col>
                            <Col>
                              <Form.Item
                                {...restField}
                                name={[name, 'pieces']}
                                label="Pieces"
                                rules={[
                                  {
                                    required: true,
                                    message: 'Please enter pieces',
                                  },
                                  {
                                    pattern: /^[1-9]\d{0,5}$/, // only allows numbers from 1 to 999999
                                    message:
                                      'Please enter pieces greater than 0',
                                  },
                                ]}
                              >
                                <Input
                                  placeholder="0"
                                  onChange={() => {
                                    setTimeout(
                                      () => handleFieldChange(index, 'pieces'),
                                      0,
                                    );
                                  }}
                                  style={{ width: '100px' }}
                                />
                              </Form.Item>
                            </Col>
                            <Col>
                              <Form.Item
                                {...restField}
                                name={[name, 'min_weight']}
                                label={`Net Weight - ${form.getFieldValue('tolerance')?.includes('-') ? form.getFieldValue('tolerance').match(/\d+/)?.[0] || '0' : '0'}%`}
                              >
                                <Input
                                  placeholder="0.0"
                                  disabled
                                  style={{ width: '100px' }}
                                />
                              </Form.Item>
                            </Col>
                            <Col>
                              <Form.Item
                                {...restField}
                                name={[name, 'net_weight']}
                                label="Net Weight (kg)"
                                rules={[
                                  createNumberValidationRule({
                                    allowNegative: false,
                                    maxBeforeDecimal: 10,
                                    maxAfterDecimal: 3,
                                    allowDecimal: true,
                                    allowZero: true,
                                  }),
                                ]}
                              >
                                <Input
                                  placeholder="0.0"
                                  onChange={e => {
                                    let value = e.target.value;
                                    handleFieldChange(index, 'net_weight', value);
                                  }}
                                  // onBlur={e => {
                                  //   const val = e.target.value;

                                  //   // 🔹 normalize ONLY after user finishes typing
                                  //   if (val !== '' && !isNaN(val)) {
                                  //     const formatted = Number(val).toFixed(3).replace(/\.?0+$/, '');
                                  //     form.setFieldValue(
                                  //       ['work_order_details', index, 'net_weight'],
                                  //       formatted
                                  //     );
                                  //   }
                                  // }}
                                  style={{ width: '100px' }}
                                />
                              </Form.Item>
                            </Col>
                            <Col>
                              <Form.Item
                                {...restField}
                                name={[name, 'max_weight']}
                                label={`Net Weight + ${form.getFieldValue('tolerance')?.includes('+') ? form.getFieldValue('tolerance').match(/\d+/)?.[0] || '0' : '0'}%`}
                              >
                                <Input
                                  placeholder="0.0"
                                  disabled
                                  style={{ width: '100px' }}
                                />
                              </Form.Item>
                            </Col>
                            <Col>
                              <label
                                className="customlabel flex"
                                style={{ marginBottom: '3px' }}
                              >
                                {' '}
                                Nalco -
                                <div className="ml-2">
                                  <Checkbox
                                    onChange={e =>
                                      handleCheckboxChange(
                                        name,
                                        e.target.checked,
                                      )
                                    }
                                    checked={checkedRows[name] || false}
                                  >
                                    Edit Rate
                                  </Checkbox>
                                </div>
                              </label>
                              <Form.Item
                                {...restField}
                                name={[name, 'nalco_rate']}
                                label=""
                                rules={[
                                  createNumberValidationRule({
                                    allowNegative: false,
                                    maxBeforeDecimal: 7,
                                    maxAfterDecimal: 3,
                                    allowDecimal: true,
                                    allowZero: true,
                                  }),
                                ]}
                              >
                                <Input
                                  disabled={!checkedRows[name]}
                                  onChange={e =>
                                    handleNalcoChange(e.target.value)
                                  }
                                  placeholder="0.0"
                                  style={{ width: '150px' }}
                                />
                              </Form.Item>
                            </Col>
                            {checkedRows[name] && (
                              <Col>
                                <Form.Item
                                  name={[name, 'nalco_rate_change_reason']}
                                  label="Remarks"
                                  rules={[
                                    {
                                      required: true,
                                      message:
                                        'Remark is required when Nalco Rate is updated',
                                    },
                                  ]}
                                >
                                  <Input placeholder="Enter Remarks" />
                                </Form.Item>
                              </Col>
                            )}
                            <Col>
                              <Form.Item
                                {...restField}
                                label="Conversion (Kg)"
                                name={[name, 'conversion']}
                                rules={[
                                  createNumberValidationRule({
                                    allowNegative: false,
                                    maxBeforeDecimal: 10,
                                    maxAfterDecimal: 2,
                                    allowDecimal: true,
                                    allowZero: true,
                                  }),
                                ]}
                              >
                                <Input
                                  placeholder="0.0"
                                  style={{ width: '100px' }}
                                />
                              </Form.Item>
                            </Col>
                            <Col>
                              <Form.Item
                                {...restField}
                                name={[name, 'packing_charge']}
                                label="Packing Charges (Kg)"
                                rules={[
                                  createNumberValidationRule({
                                    allowNegative: false,
                                    maxBeforeDecimal: 10,
                                    maxAfterDecimal: 2,
                                    allowDecimal: true,
                                    allowZero: true,
                                  }),
                                ]}
                              >
                                <Input
                                  placeholder="0"
                                  style={{ width: '100px' }}
                                />
                              </Form.Item>
                            </Col>
                            <Col xs={12} md={8} xl={6} xxl={4}>
                              <Form.Item
                                {...restField}
                                label="Surface finish"
                                name={[name, 'jobworks']}
                                rules={[
                                  {
                                    required: true,
                                    message: 'Please select surface finish',
                                  },
                                ]}
                              >
                                <AutoOpenSelect
                                  placeholder="Select Surface finish"
                                  mode="multiple"
                                  allowClear
                                  showSearch
                                  loading={jobWorkLoading}
                                  disabled={jobWorkLoading}
                                  notFoundContent={jobWorkLoading ? "Loading surface finishes..." : "No options found"}
                                  value={form.getFieldValue(['quotation_details', name, 'jobworks'])}
                                  onChange={(value) => {
                                    const selectedItems = jobWorkdata?.filter(item => value.includes(item.id));
                                    const selectedNames = selectedItems.map(item => item.name);



                                    // const laserMarkingId = jobWorkdata?.find(item => item.name === "Laser marking")?.id;
                                    const engineeringId = jobWorkdata?.find(item => item.name === "Engineering")?.id;
                                    const surfaceTreatmentId = jobWorkdata?.find(item => item.name === "Surface treatment")?.id;

                                    const details = form.getFieldValue("inquiry_details") || [];
                                    if (!details[index]) return;
                                    const newDetails = [...details];

                                    // Delete Laser Marking fields if deselected
                                    // if (!value.includes(laserMarkingId)) {
                                    //   delete newDetails[index].laser_marking_description;
                                    //   delete newDetails[index].laser_marking_price;
                                    // }

                                    // Delete Engineering-related fields if deselected
                                    if (!value.includes(engineeringId)) {
                                      ["cutting", "machining", "deburring"].forEach(opt => {
                                        if (newDetails[index][opt] !== undefined) delete newDetails[index][opt]; // remove boolean
                                        //if (newDetails[index][`${opt}_price`] !== undefined) delete newDetails[index][`${opt}_price`]; // remove price
                                      });
                                    }

                                    // Delete Surface Treatment -related fields if deselected
                                    if (!value.includes(surfaceTreatmentId)) {
                                      ["anodising", "powder_coating", "pvdf"].forEach(opt => {
                                        if (newDetails[index][opt] !== undefined) delete newDetails[index][opt]; // remove boolean
                                        if (newDetails[index][`${opt}_description`] !== undefined) delete newDetails[index][`${opt}_description`]; // remove description
                                        //if (newDetails[index][`${opt}_price`] !== undefined) delete newDetails[index][`${opt}_price`]; // remove price
                                      });
                                    }

                                    form.setFieldsValue({ inquiry_details: newDetails });
                                  }}
                                  dropdownRender={menu => <>{menu}</>}
                                >
                                  {jobWorkdata?.map(item => (
                                    <Option key={item.id} value={item.id}>
                                      {item.name}
                                    </Option>
                                  ))}
                                </AutoOpenSelect>
                              </Form.Item>
                            </Col>
                            <Form.Item
                              shouldUpdate={(prevValues, currentValues) =>
                                prevValues.work_order_details?.[index]?.jobworks !==
                                currentValues.work_order_details?.[index]?.jobworks
                              }
                              noStyle
                            >
                              {({ getFieldValue }) => {
                                const selectedSurfaceFinish = getFieldValue(["work_order_details", index, "jobworks"]) || [];
                                const selectedItems = jobWorkdata?.filter(item => selectedSurfaceFinish.includes(item.id));

                                // Example: show conditional field if Laser Marking selected
                                const hasEngineering = selectedItems.some(item => item.name === "Engineering");
                                const hasSurfaceTreatment = selectedItems.some(item => item.name === "Surface treatment");

                                return (
                                  <>
                                    {/* --- Engineering Fields --- */}
                                    {hasEngineering && (
                                      <>
                                        <Form.Item
                                          noStyle
                                          shouldUpdate={(prev, curr) =>
                                            prev.work_order_details?.[index]?.cutting !== curr.work_order_details?.[index]?.cutting ||
                                            prev.work_order_details?.[index]?.machining !== curr.work_order_details?.[index]?.machining ||
                                            prev.work_order_details?.[index]?.deburring !== curr.work_order_details?.[index]?.deburring
                                          }
                                        >
                                          {({ getFieldValue }) => {
                                            const cutting = getFieldValue(['work_order_details', index, 'cutting']);
                                            const machining = getFieldValue(['work_order_details', index, 'machining']);
                                            const deburring = getFieldValue(['work_order_details', index, 'deburring']);

                                            return (
                                              <>
                                                <Col xs={12} md={8} xl={6} xxl={6} style={{ marginTop: '24px' }}>
                                                  <Form.Item
                                                    name={[name, "cutting"]}
                                                    valuePropName="checked"
                                                    noStyle
                                                  >
                                                    <Checkbox>Cutting</Checkbox>
                                                  </Form.Item>

                                                  <Form.Item
                                                    name={[name, "machining"]}
                                                    valuePropName="checked"
                                                    noStyle
                                                  >
                                                    <Checkbox>Machining</Checkbox>
                                                  </Form.Item>

                                                  <Form.Item
                                                    name={[name, "deburring"]}
                                                    valuePropName="checked"
                                                    noStyle
                                                  >
                                                    <Checkbox>Deburring</Checkbox>
                                                  </Form.Item>
                                                </Col>

                                                {cutting && (
                                                  <Col xs={12} md={8} xl={3}>
                                                    <Form.Item
                                                      label="Cutting Price"
                                                      name={[name, 'cutting_price']}
                                                      rules={[{ required: true, message: 'Enter Cutting Price' }]}
                                                    >
                                                      <Input placeholder="0.0" />
                                                    </Form.Item>
                                                  </Col>
                                                )}

                                                {machining && (
                                                  <Col xs={12} md={8} xl={3}>
                                                    <Form.Item
                                                      label="Machining Price"
                                                      name={[name, 'machining_price']}
                                                      rules={[{ required: true, message: 'Enter Machining Price' }]}
                                                    >
                                                      <Input placeholder="0.0" />
                                                    </Form.Item>
                                                  </Col>
                                                )}

                                                {deburring && (
                                                  <Col xs={12} md={8} xl={3}>
                                                    <Form.Item
                                                      label="Deburring Price"
                                                      name={[name, 'deburring_price']}
                                                      rules={[{ required: true, message: 'Enter Deburring Price' }]}
                                                    >
                                                      <Input placeholder="0.0" />
                                                    </Form.Item>
                                                  </Col>
                                                )}
                                              </>
                                            );
                                          }}
                                        </Form.Item>
                                      </>
                                    )}
                                    {/* --- Surface Treatment Fields --- */}
                                    {hasSurfaceTreatment && (
                                      <>
                                        {/* Nested conditional price fields */}
                                        <Form.Item
                                          noStyle
                                          shouldUpdate={(prev, curr) =>
                                            prev.work_order_details?.[index]?.anodising !== curr.work_order_details?.[index]?.anodising ||
                                            prev.work_order_details?.[index]?.powder_coating !== curr.work_order_details?.[index]?.powder_coating ||
                                            prev.work_order_details?.[index]?.pvdf !== curr.work_order_details?.[index]?.pvdf
                                          }
                                        >
                                          {({ getFieldValue }) => {
                                            const anodising = getFieldValue(["work_order_details", index, "anodising"]);
                                            const powder_coating = getFieldValue(["work_order_details", index, "powder_coating"]);
                                            const pvdf = getFieldValue(["work_order_details", index, "pvdf"]);
                                            return (
                                              <>
                                                <Col xs={12} md={8} xl={6} xxl={6} style={{ marginTop: '24px' }}>
                                                  <Form.Item
                                                    name={[name, "anodising"]}
                                                    valuePropName="checked"
                                                    noStyle
                                                  >
                                                    <Checkbox>Anodising</Checkbox>
                                                  </Form.Item>

                                                  <Form.Item
                                                    name={[name, "powder_coating"]}
                                                    valuePropName="checked"
                                                    noStyle
                                                  >
                                                    <Checkbox>Powder Coating</Checkbox>
                                                  </Form.Item>

                                                  <Form.Item
                                                    name={[name, "pvdf"]}
                                                    valuePropName="checked"
                                                    noStyle
                                                  >
                                                    <Checkbox>PVDF</Checkbox>
                                                  </Form.Item>
                                                </Col>
                                                {anodising && (
                                                  <>
                                                    <Col xs={12} md={8} xl={3}>
                                                      <Form.Item
                                                        label="Anodising Description"
                                                        name={[name, "anodising_description"]}
                                                        rules={[{ required: true, message: "Enter Anodising Description" }]}
                                                      >
                                                        <Input placeholder="Enter Anodising Description" />
                                                      </Form.Item>
                                                    </Col>
                                                    <Col xs={12} md={8} xl={3}>
                                                      <Form.Item
                                                        label="Anodising Price"
                                                        name={[name, "anodising_price"]}
                                                        rules={[{ required: true, message: "Enter Anodising Price" }]}
                                                      >
                                                        <Input placeholder="Enter Anodising Price" />
                                                      </Form.Item>
                                                    </Col>
                                                  </>
                                                )}

                                                {powder_coating && (
                                                  <>
                                                    <Col xs={12} md={8} xl={4}>
                                                      <Form.Item
                                                        label="Powder Coating Description"
                                                        name={[name, "powder_coating_description"]}
                                                        rules={[{ required: true, message: "Enter Powder Coating Description" }]}
                                                      >
                                                        <Input placeholder="Enter Powder Coating Description" />
                                                      </Form.Item>
                                                    </Col>
                                                    <Col xs={12} md={8} xl={3}>
                                                      <Form.Item
                                                        label="Powder Coating Price"
                                                        name={[name, "powder_coating_price"]}
                                                        rules={[{ required: true, message: "Enter Powder Coating Price" }]}
                                                      >
                                                        <Input placeholder="Enter Powder Coating Price" />
                                                      </Form.Item>
                                                    </Col>
                                                  </>
                                                )}

                                                {pvdf && (
                                                  <>
                                                    <Col xs={12} md={8} xl={3}>
                                                      <Form.Item
                                                        label="PVDF Description"
                                                        name={[name, "pvdf_description"]}
                                                        rules={[{ required: true, message: "Enter PVDF Description" }]}
                                                      >
                                                        <Input placeholder="Enter PVDF Description" />
                                                      </Form.Item>
                                                    </Col>
                                                    <Col xs={12} md={8} xl={3}>
                                                      <Form.Item
                                                        label="PVDF Price"
                                                        name={[name, "pvdf_price"]}
                                                        rules={[{ required: true, message: "Enter PVDF Price" }]}
                                                      >
                                                        <Input placeholder="Enter PVDF Price" />
                                                      </Form.Item>
                                                    </Col>
                                                  </>
                                                )}
                                              </>
                                            );
                                          }}
                                        </Form.Item>
                                      </>
                                    )}
                                  </>
                                );
                              }}
                            </Form.Item>
                          </Row>
                        </Col>
                        <Col>
                          <div className="addwrp">
                            {index !== 0 && (
                              <Button
                                type="primary"
                                danger
                                icon={<MinusCircleOutlined />}
                                onClick={() => remove(name)}
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                }}
                              />
                            )}
                          </div>
                        </Col>
                      </Row>
                    </div>
                  ))}
                  <Form.Item>
                    <div className="w-100 flex justify-end ">
                      <Button
                        type="primary"
                        onClick={() => {
                          if (fields.length < 500) {
                            dispatch(resetDieProfileData());
                            dispatch(
                              fetchDieProfileDropdown({ page: 1, pagesize: 100 }),
                            );
                            setSearchDieProfile('');
                            add({ nalco_rate: pricePerKg, jobworks: [1] });
                          } else {
                            message.error('You can only add up to 15 records.');
                          }
                        }}
                        icon={<PlusOutlined />}
                      >
                        Add Item
                      </Button>
                    </div>
                  </Form.Item>
                </>
              )}
            </Form.List>
          </div>
          <div className="flex justify-end">
            <Button
              type="primary"
              htmlType="submit"
              icon={<PlusOutlined />}
              loading={btnLoading}
            >
              Create Work Order
            </Button>
          </div>
        </Form>
      </div>
    </>
  );
}

export default CreateWorkOrder;
